export default function LoadingState({ label = 'Loading' }) {
  return (
    <div className="state-panel">
      <div className="hex-spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}
